export const SUPPORTED_LOCALES = ["en", "hi"] as const;

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_COOKIE = "lms_locale";

export const DEFAULT_LOCALE: AppLocale = "en";

export function isSupportedLocale(value: string): value is AppLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function resolveLocale(input: string | null | undefined): AppLocale {
  if (!input) return DEFAULT_LOCALE;
  const normalized = input.toLowerCase();
  if (normalized === "hi") return "hi";
  if (normalized === "en") return "en";
  return DEFAULT_LOCALE;
}
